class FinancingDrawer {
  constructor() {
    this.drawer = document.getElementById('FinancingDrawer');
    if (!this.drawer) return;

    this.overlay = document.getElementById('DrawerOverlay');
    this.closeButton = this.drawer.querySelector('.drawer__close-button');
    this.triggers = document.querySelectorAll('[data-open-financing-drawer]');
    this.dropdownButton = this.drawer.querySelector('.select');
    this.popover = document.getElementById('financing-rates');
    this.listboxOptions = this.drawer.querySelectorAll('.popover-listbox__option');
    this.selectedValueElement = document.getElementById('financing-rates-selected-value');
    
    this.monthlyRateElement = this.drawer.querySelector('[data-monthly-rate]');
    this.borrowingRateElement = this.drawer.querySelector('[data-borrowing-rate]');
    this.annualRateElement = this.drawer.querySelector('[data-annual-percentage-rate]');
    this.finalPriceElement = this.drawer.querySelector('[data-final-price]');
    
    const configElement = this.drawer.querySelector('[data-config]');
    if (configElement && configElement.textContent) {
        try {
            this.config = JSON.parse(configElement.textContent);
        } catch (e) {
            console.error('Error parsing financing config:', e);
            this.config = {};
        }
    } else {
        this.config = {};
    }
    
    this.initEvents();
  }
  
  initEvents() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.openDrawer();
      });
    });
    
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeDrawer());
    }
    
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeDrawer());
    }
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isDrawerOpen()) {
        this.closeDrawer();
      }
    });
    
    if (this.dropdownButton) {
      this.dropdownButton.addEventListener('click', () => this.togglePopover());
    }
    
    this.listboxOptions.forEach(option => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('value');
        const title = option.getAttribute('title');
        
        if (this.selectedValueElement) {
            this.selectedValueElement.textContent = title;
        }
        
        this.listboxOptions.forEach(opt => {
          opt.setAttribute('aria-selected', opt === option ? 'true' : 'false');
        });
        
        this.updateFinancingInfo(value);
        this.closePopover();
      });
    });
    
    document.addEventListener('click', (e) => {
      if (this.isPopoverOpen() && this.popover && !this.popover.contains(e.target) && this.dropdownButton && !this.dropdownButton.contains(e.target)) {
        this.closePopover();
      }
    });
  }
  
  openDrawer() {
    if (!this.drawer || !this.overlay) return;
    this.drawer.setAttribute('open', '');
    this.overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  closeDrawer() {
    if (!this.drawer || !this.overlay) return;
    this.drawer.removeAttribute('open');
    this.overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  isDrawerOpen() {
    return this.drawer && this.drawer.hasAttribute('open');
  }
  
  togglePopover() {
    if (this.isPopoverOpen()) {
      this.closePopover();
    } else {
      this.openPopover();
    }
  }
  
  openPopover() {
    if (!this.popover || !this.dropdownButton) return;
    this.popover.setAttribute('open', '');
    this.dropdownButton.setAttribute('aria-expanded', 'true');
  }
  
  closePopover() {
    if (!this.popover || !this.dropdownButton) return;
    this.popover.removeAttribute('open');
    this.dropdownButton.setAttribute('aria-expanded', 'false');
  }
  
  isPopoverOpen() {
    return this.popover && this.popover.hasAttribute('open');
  }
  
  updateFinancingInfo(term) {
    if (!this.config || !this.config.values || !this.config.values[term]) return;
    const termData = this.config.values[term];
    
    if (this.monthlyRateElement) this.monthlyRateElement.textContent = termData.monthlyRate;
    if (this.borrowingRateElement) this.borrowingRateElement.textContent = termData.borrowingRate;
    if (this.annualRateElement) this.annualRateElement.textContent = termData.annualPercentageRate;
    if (this.finalPriceElement) this.finalPriceElement.textContent = termData.finalPrice;
  }
}

window.initializeFinancingDrawer = function() {
  if (document.getElementById('FinancingDrawer')) {
    new FinancingDrawer();
  }
}

document.addEventListener('DOMContentLoaded', window.initializeFinancingDrawer);
